import { whiteColor, blackColors, grayColor } from 'assets/jss/material-dashboard-pro-react';

const servicesStyle = (theme) => ({
	accordionWrapper: {
		'& .MuiExpansionPanelSummary-root.MuiButtonBase-root': {
			borderBottomWidth: '2px',
			transition: 'all .1s ease-in-out',
			'&.Mui-expanded': {
				borderColor: blackColors[4],
			},
		},
		'& .MuiExpansionPanelDetails-root': {
			backgroundColor: grayColor[3],
		},
		'& .MuiExpansionPanelSummary-content': {
			'& > div:last-of-type': {
				marginLeft: 21,
			},
		},
	},
	iconWrapper: {
		marginRight: 16,
	},
	iconDisabledWrapper: {
		opacity: '0.38',
	},
	tileNameDisabled: {
		opacity: '0.38',
	},
	accordionContentWrapper: {
		paddingTop: 16,
		paddingBottom: 16,
		margin: 0,
	},
	accordionTileWrapper: {
		padding: '0!important',
	},
	accordionTile: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		padding: 16,
		margin: 8,
		borderRadius: 8,
		boxShadow: '0 8px 12px -6px rgba(0, 0, 0, 0.5)',
		backgroundColor: whiteColor,
		minHeight: 80,
		height: 'calc(100% - 16px)',
		cursor: 'pointer',
	},
	accordionTileDisabled: {
		boxShadow: 'none',
		cursor: 'auto',
	},
	comingSoon: {
		position: 'absolute',
		bottom: 4,
		right: 16,
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	headingWrapper: {
		marginBottom: 24,
		marginTop: 16,
	},
	heading: {
		margin: 0,
	},
});

export default servicesStyle;
